import React from 'react';

const EmptyTeamsAndUsersIcon = () => (
  <svg
    width="172"
    height="172"
    viewBox="0 0 172 172"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="86" cy="86" r="86" fill="#F2FBFD" />
    <rect
      x="91.0432"
      y="39.9372"
      width="66.9091"
      height="82"
      rx="7.5"
      transform="rotate(8.64542 91.0432 39.9372)"
      fill="white"
      stroke="#90E0EF"
    />
    <rect
      x="93.9639"
      y="89.9087"
      width="45.2727"
      height="2.51515"
      transform="rotate(8.64542 93.9639 89.9087)"
      fill="#EAEAF1"
    />
    <rect
      x="93.0818"
      y="95.7107"
      width="17.6061"
      height="2.51515"
      transform="rotate(8.64542 93.0818 95.7107)"
      fill="#EAEAF1"
    />
    <rect
      x="91.9475"
      y="103.17"
      width="13.4141"
      height="5.86869"
      rx="2"
      transform="rotate(8.64542 91.9475 103.17)"
      fill="#ADE8F4"
    />
    <rect
      x="107.696"
      y="105.565"
      width="13.4141"
      height="5.86869"
      rx="2"
      transform="rotate(8.64542 107.696 105.565)"
      fill="#ADE8F4"
    />
    <rect
      x="123.444"
      y="107.959"
      width="13.4141"
      height="5.86869"
      rx="2"
      transform="rotate(8.64542 123.444 107.959)"
      fill="#ADE8F4"
    />
    <g clipPath="url(#clip0_70_79814)">
      <path
        d="M120.773 75.3285L118.287 74.9504C118.665 72.4638 120.117 71.8366 121.104 71.4779C121.461 71.3626 121.735 71.2346 121.926 71.094C122.403 70.7426 122.326 70.1372 122.268 69.9588C122.108 69.3408 121.616 68.6724 120.538 68.5086C118.797 68.2439 118.226 69.7683 118.176 70.0999L115.74 69.3903C116.12 68.0064 117.766 65.5431 120.916 66.022C122.823 66.3119 124.316 67.6414 124.74 69.3171C125.106 70.8143 124.63 72.2685 123.485 73.1119C123.007 73.4633 122.472 73.6363 122.02 73.822C121.211 74.123 120.899 74.4996 120.773 75.3285Z"
        fill="black"
      />
      <path
        d="M120.81 77.8782C120.781 78.0997 120.709 78.3133 120.596 78.5064C120.484 78.6995 120.334 78.8682 120.156 79.0026C119.978 79.1371 119.774 79.2345 119.558 79.2893C119.341 79.344 119.116 79.355 118.895 79.3215C118.674 79.2879 118.462 79.2106 118.272 79.0941C118.081 78.9776 117.916 78.8241 117.785 78.6428C117.655 78.4615 117.562 78.2559 117.512 78.0382C117.462 77.8205 117.456 77.5951 117.495 77.375C117.57 76.9434 117.812 76.5584 118.167 76.3025C118.523 76.0466 118.965 75.9401 119.398 76.0059C119.832 76.0717 120.222 76.3044 120.486 76.6543C120.749 77.0043 120.866 77.4436 120.81 77.8782Z"
        fill="black"
      />
      <rect
        x="116.251"
        y="77.1851"
        width="5.86869"
        height="1.67677"
        transform="rotate(8.64542 116.251 77.1851)"
        fill="#C4C4C4"
      />
    </g>
    <circle
      cx="120.349"
      cy="69.7518"
      r="16.3485"
      transform="rotate(8.64542 120.349 69.7518)"
      fill="#CAF0F8"
    />
    <path
      d="M118.728 72.692C118.848 71.9025 119.041 71.2882 119.308 70.8491C119.576 70.4099 120.039 69.9551 120.7 69.4847C121.367 69.0093 121.796 68.6645 121.987 68.4506C122.279 68.1246 122.458 67.7509 122.522 67.3294C122.607 66.7715 122.532 66.3258 122.297 65.9926C122.069 65.6543 121.688 65.4445 121.154 65.3633C120.643 65.2856 120.208 65.3684 119.85 65.6114C119.498 65.8494 119.284 66.2147 119.209 66.7074L117.046 66.3784C117.217 65.3296 117.7 64.5527 118.493 64.0478C119.293 63.5438 120.271 63.3798 121.428 63.5558C122.622 63.7372 123.504 64.1812 124.077 64.8877C124.656 65.5952 124.863 66.492 124.698 67.5783C124.55 68.5458 123.954 69.4299 122.91 70.2306L121.651 71.1414C121.191 71.5271 120.891 72.1463 120.749 72.9993L118.728 72.692ZM118.155 75.438C118.208 75.0878 118.361 74.8226 118.613 74.6423C118.866 74.456 119.18 74.3913 119.554 74.4482C119.934 74.506 120.216 74.6643 120.401 74.9233C120.588 75.1763 120.655 75.472 120.604 75.8103C120.554 76.1368 120.406 76.3936 120.159 76.5807C119.912 76.7679 119.592 76.8317 119.2 76.7721C118.809 76.7125 118.523 76.5567 118.342 76.3046C118.168 76.0533 118.105 75.7645 118.155 75.438Z"
      fill="#0096C7"
    />
    <rect
      x="122.26"
      y="44.178"
      width="15"
      height="83"
      transform="rotate(8.64542 122.26 44.178)"
      fill="#CAF0F8"
      fillOpacity="0.5"
    />
    <rect
      x="15.0074"
      y="49.6762"
      width="66.9091"
      height="82"
      rx="7.5"
      transform="rotate(-8.17847 15.0074 49.6762)"
      fill="white"
      stroke="#90E0EF"
    />
    <rect
      x="32.2664"
      y="96.6636"
      width="45.2727"
      height="2.51515"
      transform="rotate(-8.17847 32.2664 96.6636)"
      fill="#EAEAF1"
    />
    <rect
      x="33.1013"
      y="102.473"
      width="17.6061"
      height="2.51515"
      transform="rotate(-8.17847 33.1013 102.473)"
      fill="#EAEAF1"
    />
    <rect
      x="34.1746"
      y="109.941"
      width="13.4141"
      height="5.86869"
      rx="2"
      transform="rotate(-8.17847 34.1746 109.941)"
      fill="#ADE8F4"
    />
    <rect
      x="49.9419"
      y="107.675"
      width="13.4141"
      height="5.86869"
      rx="2"
      transform="rotate(-8.17847 49.9419 107.675)"
      fill="#ADE8F4"
    />
    <rect
      x="65.7092"
      y="105.409"
      width="13.4141"
      height="5.86869"
      rx="2"
      transform="rotate(-8.17847 65.7092 105.409)"
      fill="#ADE8F4"
    />
    <g clipPath="url(#clip1_70_79814)">
      <path
        d="M53.7083 74.9481L51.2188 75.3059C50.861 72.8163 52.0695 71.7957 52.9107 71.1665C53.2188 70.9529 53.4439 70.7511 53.5861 70.5613C53.9414 70.0867 53.6919 69.5297 53.5851 69.3756C53.2526 68.8305 52.5882 68.3331 51.5094 68.4882C49.7667 68.7386 49.6614 70.363 49.7091 70.695L47.1718 70.7208C47.135 69.2862 47.9982 66.4518 51.1516 65.9986C53.0603 65.7243 54.8751 66.5645 55.7655 68.0459C56.5492 69.3731 56.5149 70.9027 55.6622 72.0416C55.3069 72.5162 54.8448 72.8367 54.4656 73.1453C53.7784 73.6675 53.5891 74.1183 53.7083 74.9481Z"
        fill="black"
      />
      <path
        d="M54.4811 77.3781C54.5179 77.5984 54.5102 77.8238 54.4587 78.0412C54.4071 78.2585 54.3127 78.4633 54.1809 78.6436C54.0491 78.8239 53.8826 78.9761 53.6911 79.0912C53.4997 79.2062 53.2872 79.2819 53.0661 79.3137C52.8451 79.3456 52.6199 79.3329 52.4038 79.2765C52.1876 79.2201 51.985 79.1211 51.8077 78.9853C51.6303 78.8495 51.4819 78.6796 51.3712 78.4857C51.2604 78.2917 51.1895 78.0776 51.1626 77.8559C51.1099 77.4208 51.2296 76.9825 51.496 76.6346C51.7625 76.2867 52.1545 76.0569 52.5883 75.9944C53.022 75.932 53.4629 76.0418 53.8167 76.3004C54.1705 76.559 54.409 76.9459 54.4811 77.3781Z"
        fill="black"
      />
      <rect
        x="49.917"
        y="78.0339"
        width="5.86869"
        height="1.67677"
        transform="rotate(-8.17847 49.917 78.0339)"
        fill="#C4C4C4"
      />
    </g>
    <circle
      cx="51.6883"
      cy="69.7327"
      r="16.3485"
      transform="rotate(-8.17847 51.6883 69.7327)"
      fill="#CAF0F8"
    />
    <path
      d="M50.9872 73.0165C50.8736 72.2261 50.8811 71.582 51.0098 71.0843C51.1384 70.5867 51.4508 70.0171 51.947 69.3756C52.4483 68.7273 52.7591 68.2732 52.8794 68.0133C53.0651 67.6166 53.1276 67.2073 53.0669 66.7853C52.9866 66.2267 52.7859 65.8218 52.4647 65.5707C52.1486 65.3129 51.7232 65.2224 51.1883 65.2993C50.6772 65.3727 50.2851 65.5777 50.012 65.9142C49.7439 66.2438 49.6453 66.6553 49.7162 67.1486L47.55 67.4599C47.4107 66.4063 47.6477 65.523 48.261 64.8101C48.8803 64.0963 49.7693 63.6562 50.9282 63.4896C52.1228 63.3179 53.0964 63.4874 53.8491 63.9979C54.6078 64.5076 55.0653 65.3062 55.2216 66.3937C55.3608 67.3625 55.0462 68.3812 54.2779 69.45L53.3364 70.6863C53.0082 71.1884 52.8997 71.8682 53.0108 72.7257L50.9872 73.0165ZM51.2341 75.8107C51.1837 75.46 51.2531 75.1619 51.4422 74.9164C51.6305 74.6649 51.9119 74.5123 52.2863 74.4584C52.6666 74.4038 52.983 74.4736 53.2353 74.6678C53.4868 74.8561 53.6369 75.1196 53.6856 75.4584C53.7326 75.7852 53.6649 76.074 53.4825 76.3246C53.3002 76.5752 53.0129 76.7288 52.6207 76.7851C52.2284 76.8415 51.9095 76.7751 51.664 76.586C51.4244 76.396 51.2811 76.1375 51.2341 75.8107Z"
      fill="#0096C7"
    />
    <rect
      x="46.116"
      y="44.7002"
      width="15"
      height="83"
      transform="rotate(-8.17847 46.116 44.7002)"
      fill="#CAF0F8"
      fillOpacity="0.5"
    />
    <rect
      x="38.1973"
      y="45.8384"
      width="15"
      height="83"
      transform="rotate(-8.17847 38.1973 45.8384)"
      fill="#CAF0F8"
      fillOpacity="0.5"
    />
    <rect x="47.5" y="36.5" width="80" height="98" rx="7.5" fill="white" stroke="#90E0EF" />
    <rect x="60" y="95" width="54" height="3" fill="#EAEAF1" />
    <rect x="60" y="102" width="21" height="3" fill="#EAEAF1" />
    <rect x="60" y="111" width="16" height="7" rx="2" fill="#ADE8F4" />
    <rect x="79" y="111" width="16" height="7" rx="2" fill="#ADE8F4" />
    <rect x="98" y="111" width="16" height="7" rx="2" fill="#ADE8F4" />
    <g clipPath="url(#clip2_70_79814)">
      <path
        d="M89 73H86C86 70 87.6 69 88.7 68.4C89.1 68.2 89.4 68 89.6 67.8C90.1 67.3 89.9 66.6 89.8 66.4C89.5 65.7 88.8 65 87.5 65C85.4 65 85 66.9 85 67.3L82 66.9C82.2 65.2 83.7 62 87.5 62C89.8 62 91.8 63.3 92.6 65.2C93.3 66.9 93 68.7 91.8 69.9C91.3 70.4 90.7 70.7 90.2 71C89.3 71.5 89 72 89 73Z"
        fill="black"
      />
      <path
        d="M89.5 76C89.506 76.2663 89.4588 76.5311 89.361 76.779C89.2633 77.0268 89.117 77.2526 88.9308 77.4431C88.7446 77.6336 88.5222 77.785 88.2766 77.8884C88.0311 77.9918 87.7674 78.0451 87.501 78.0452C87.2346 78.0452 86.9708 77.9921 86.7253 77.8888C86.4797 77.7855 86.2572 77.6343 86.0709 77.4438C85.8846 77.2534 85.7382 77.0277 85.6403 76.7799C85.5425 76.5321 85.4951 76.2673 85.501 76.001C85.5125 75.4784 85.7282 74.9811 86.1018 74.6156C86.4754 74.25 86.9773 74.0453 87.5 74.0452C88.0227 74.045 88.5246 74.2495 88.8984 74.6149C89.2722 74.9802 89.4882 75.4774 89.5 76Z"
        fill="black"
      />
      <rect x="84" y="76" width="7" height="2" fill="#C4C4C4" />
    </g>
    <circle cx="87.5" cy="66.5" r="19.5" fill="#CAF0F8" />
    <path
      d="M86.1152 70.2578C86.1152 69.3053 86.2334 68.5462 86.4697 67.9805C86.7061 67.4147 87.1715 66.7952 87.8662 66.1221C88.568 65.4417 89.012 64.9583 89.1982 64.6719C89.4847 64.235 89.6279 63.7624 89.6279 63.2539C89.6279 62.5807 89.4596 62.0687 89.123 61.7178C88.7936 61.3597 88.3066 61.1807 87.6621 61.1807C87.0462 61.1807 86.5485 61.3561 86.1689 61.707C85.7965 62.0508 85.6104 62.5199 85.6104 63.1143H83C83.0143 61.8467 83.444 60.8441 84.2891 60.1064C85.1413 59.3688 86.2656 59 87.6621 59C89.1016 59 90.2223 59.3652 91.0244 60.0957C91.8337 60.8262 92.2383 61.8467 92.2383 63.1572C92.2383 64.3245 91.694 65.474 90.6055 66.6055L89.2842 67.9053C88.8115 68.4424 88.568 69.2266 88.5537 70.2578H86.1152ZM85.9326 73.5986C85.9326 73.1761 86.0651 72.8359 86.3301 72.5781C86.5951 72.3132 86.9531 72.1807 87.4043 72.1807C87.8626 72.1807 88.2243 72.3167 88.4893 72.5889C88.7542 72.8538 88.8867 73.1904 88.8867 73.5986C88.8867 73.9925 88.7578 74.3219 88.5 74.5869C88.2422 74.8519 87.877 74.9844 87.4043 74.9844C86.9316 74.9844 86.5664 74.8519 86.3086 74.5869C86.0579 74.3219 85.9326 73.9925 85.9326 73.5986Z"
      fill="#0096C7"
    />
    <defs>
      <clipPath id="clip0_70_79814">
        <rect
          width="13.4141"
          height="13.4141"
          fill="white"
          transform="translate(114.7 65.0769) rotate(8.64542)"
        />
      </clipPath>
      <clipPath id="clip1_70_79814">
        <rect
          width="13.4141"
          height="13.4141"
          fill="white"
          transform="translate(44.9277 66.8931) rotate(-8.17847)"
        />
      </clipPath>
      <clipPath id="clip2_70_79814">
        <rect width="16" height="16" fill="white" transform="translate(80 62)" />
      </clipPath>
    </defs>
  </svg>
);

export default EmptyTeamsAndUsersIcon;
